/*
    requestAnimationFrame polyfill
    Babel does not polyfill browser APIs 
*/
window.requestAnimationFrame = window.requestAnimationFrame || function (callback) {
    return window.setTimeout(callback, 1000 / 60);
};
window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;

/*
    NodeList.prototype.forEach polyfill
    @babel/preset-env does not include this polyfill, even with corejs: 3, because NodeList.prototype.forEach is a browser-native API, not a language feature.
*/
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}